/* ==========================================================================
   VyomTara | Product Slider
   Self-contained: tabs, arrow scrolling, autoplay, and the quick view popup.
   Everything lives inside one IIFE with a "vtPs" namespace, so it cannot
   clash with vt-collection-grid or any theme script.
   ========================================================================== */

(function () {
  'use strict';

  if (window.vtPsSliderLoaded) return;
  window.vtPsSliderLoaded = true;

  /* ---------- Money ---------- */
  function vtPsMoney(cents, format) {
    var value = (cents || 0) / 100;
    var fmt = format || '₹{{amount}}';

    function withCommas(num, decimals) {
      var fixed = num.toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0];
      var rest = parts[1];
      // Indian grouping: last 3 digits, then pairs
      var lastThree = whole.slice(-3);
      var other = whole.slice(0, -3);
      if (other) lastThree = ',' + lastThree;
      other = other.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      var out = other + lastThree;
      return rest ? out + '.' + rest : out;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(Math.round(value), 0);
        case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return String(Math.round(value));
        case 'amount_with_space_separator': return withCommas(value, 2).replace(/,/g, ' ');
        case 'amount_no_decimals_with_space_separator': return withCommas(Math.round(value), 0).replace(/,/g, ' ');
        default: return withCommas(value, 2);
      }
    });
  }

  /* ---------- Popup ---------- */
  var vtPsPop = null;
  var vtPsState = { product: null, selected: [], root: null, imageIndex: 0 };

  function vtPsBuildPop() {
    if (vtPsPop) return vtPsPop;
    vtPsPop = document.createElement('div');
    vtPsPop.className = 'vt-ps-pop';
    vtPsPop.hidden = true;
    vtPsPop.innerHTML =
      '<div class="vt-ps-pop__overlay" data-vt-ps-pop-close></div>' +
      '<div class="vt-ps-pop__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<button type="button" class="vt-ps-pop__close" data-vt-ps-pop-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="vt-ps-pop__body"></div>' +
      '</div>';
    document.body.appendChild(vtPsPop);

    vtPsPop.addEventListener('click', function (e) {
      if (e.target.closest('[data-vt-ps-pop-close]')) vtPsClosePop();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && vtPsPop && !vtPsPop.hidden) vtPsClosePop();
    });
    return vtPsPop;
  }

  function vtPsOpenPop() {
    vtPsBuildPop().hidden = false;
    document.documentElement.classList.add('vt-ps-lock');
  }

  function vtPsClosePop() {
    if (!vtPsPop) return;
    vtPsPop.hidden = true;
    document.documentElement.classList.remove('vt-ps-lock');
    vtPsState.product = null;
  }

  function vtPsPanel() {
    return vtPsPop.querySelector('.vt-ps-pop__panel');
  }

  function vtPsBody() {
    return vtPsPop.querySelector('.vt-ps-pop__body');
  }

  function vtPsSetLoading() {
    vtPsPanel().classList.remove('vt-ps-pop__panel--ready');
    vtPsBody().innerHTML = '<div class="vt-ps-pop__loading">Loading…</div>';
  }

  function vtPsCurrentVariant() {
    var p = vtPsState.product;
    if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      var match = true;
      for (var j = 0; j < vtPsState.selected.length; j++) {
        if (v.options[j] !== vtPsState.selected[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function vtPsVariantExists(optionIndex, value) {
    var p = vtPsState.product;
    return p.variants.some(function (v) {
      if (v.options[optionIndex] !== value) return false;
      for (var j = 0; j < optionIndex; j++) {
        if (v.options[j] !== vtPsState.selected[j]) return false;
      }
      return v.available;
    });
  }

  function vtPsRender(product, url, root) {
    vtPsState.product = product;
    vtPsState.root = root;
    vtPsState.imageIndex = 0;
    vtPsState.selected = (product.variants[0] && product.variants[0].options.slice()) || [];

    var firstAvailable = product.variants.find(function (v) { return v.available; });
    if (firstAvailable) vtPsState.selected = firstAvailable.options.slice();

    var format = root.dataset.moneyFormat || '₹{{amount}}';
    var images = (product.images && product.images.length) ? product.images : [];

    var html = '';

    html += '<div class="vt-ps-pop__gallery">';
    html += '<div class="vt-ps-pop__main">';
    html += images.length ? '<img src="' + images[0] + '" alt="" data-vt-ps-pop-main>' : '';
    html += '</div>';
    if (images.length > 1) {
      html += '<div class="vt-ps-pop__thumbs">';
      images.slice(0, 8).forEach(function (src, i) {
        html += '<button type="button" class="vt-ps-pop__thumb' + (i === 0 ? ' is-active' : '') +
                '" data-vt-ps-pop-thumb="' + i + '"><img src="' + src + '" alt=""></button>';
      });
      html += '</div>';
    }
    html += '</div>';

    html += '<div class="vt-ps-pop__details">';
    html += '<h2 class="vt-ps-pop__title">' + product.title + '</h2>';
    html += '<p class="vt-ps-pop__price" data-vt-ps-pop-price></p>';

    if (product.options && product.options.length && !(product.options.length === 1 && product.options[0].name === 'Title')) {
      product.options.forEach(function (opt, index) {
        var name = typeof opt === 'string' ? opt : opt.name;
        var values = typeof opt === 'string'
          ? product.variants.reduce(function (acc, v) {
              if (acc.indexOf(v.options[index]) === -1) acc.push(v.options[index]);
              return acc;
            }, [])
          : opt.values;

        html += '<div class="vt-ps-pop__option" data-option-index="' + index + '">';
        html += '<p class="vt-ps-pop__opt-name">' + name + '</p>';
        html += '<div class="vt-ps-pop__values">';
        values.forEach(function (val) {
          html += '<button type="button" class="vt-ps-pop__value" data-vt-ps-pop-value="' + index +
                  '" data-value="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</button>';
        });
        html += '</div></div>';
      });
    }

    html += '<div><p class="vt-ps-pop__qty-label">Quantity</p>';
    html += '<div class="vt-ps-pop__qty">' +
            '<button type="button" data-vt-ps-pop-minus aria-label="Decrease">−</button>' +
            '<input type="number" value="1" min="1" data-vt-ps-pop-qty aria-label="Quantity">' +
            '<button type="button" data-vt-ps-pop-plus aria-label="Increase">+</button>' +
            '</div></div>';

    html += '<button type="button" class="vt-ps-pop__atc" data-vt-ps-pop-atc>Add to cart</button>';
    html += '<p class="vt-ps-pop__msg" data-vt-ps-pop-msg></p>';
    html += '<a class="vt-ps-pop__link" href="' + url + '">View full details</a>';
    html += '</div>';

    vtPsBody().innerHTML = html;
    vtPsSync(format);
  }

  function vtPsSync(format) {
    var variant = vtPsCurrentVariant();
    var priceEl = vtPsPop.querySelector('[data-vt-ps-pop-price]');
    var atc = vtPsPop.querySelector('[data-vt-ps-pop-atc]');

    vtPsPop.querySelectorAll('[data-vt-ps-pop-value]').forEach(function (btn) {
      var index = parseInt(btn.dataset.vtPsPopValue, 10);
      var value = btn.dataset.value;
      btn.classList.toggle('is-selected', vtPsState.selected[index] === value);
      btn.classList.toggle('is-unavailable', !vtPsVariantExists(index, value));
    });

    if (priceEl) {
      if (variant) {
        var out = '<span>' + vtPsMoney(variant.price, format) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          out += '<s class="vt-ps-pop__was">' + vtPsMoney(variant.compare_at_price, format) + '</s>';
        }
        priceEl.innerHTML = out;
      } else {
        priceEl.textContent = '';
      }
    }

    if (atc) {
      if (!variant) {
        atc.disabled = true;
        atc.textContent = 'Unavailable';
      } else if (!variant.available) {
        atc.disabled = true;
        atc.textContent = 'Sold out';
      } else {
        atc.disabled = false;
        atc.textContent = 'Add to cart';
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (!vtPsPop || vtPsPop.hidden) return;

    var thumb = e.target.closest('[data-vt-ps-pop-thumb]');
    if (thumb) {
      var i = parseInt(thumb.dataset.vtPsPopThumb, 10);
      var main = vtPsPop.querySelector('[data-vt-ps-pop-main]');
      if (main && vtPsState.product.images[i]) main.src = vtPsState.product.images[i];
      vtPsPop.querySelectorAll('[data-vt-ps-pop-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    var valueBtn = e.target.closest('[data-vt-ps-pop-value]');
    if (valueBtn) {
      var idx = parseInt(valueBtn.dataset.vtPsPopValue, 10);
      vtPsState.selected[idx] = valueBtn.dataset.value;
      vtPsSync(vtPsState.root.dataset.moneyFormat);
      return;
    }

    var qtyInput = vtPsPop.querySelector('[data-vt-ps-pop-qty]');
    if (e.target.closest('[data-vt-ps-pop-minus]') && qtyInput) {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      return;
    }
    if (e.target.closest('[data-vt-ps-pop-plus]') && qtyInput) {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      return;
    }

    if (e.target.closest('[data-vt-ps-pop-atc]')) {
      var variant = vtPsCurrentVariant();
      var msg = vtPsPop.querySelector('[data-vt-ps-pop-msg]');
      var btn = e.target.closest('[data-vt-ps-pop-atc]');
      if (!variant || !variant.available) return;

      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: parseInt(qtyInput.value, 10) || 1 })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
          btn.textContent = 'Added';
          if (msg) { msg.classList.remove('is-error'); msg.textContent = 'Added to your cart.'; }
          document.dispatchEvent(new CustomEvent('vt-ps:added', { detail: res.data }));

          if (vtPsState.root.dataset.openCart === 'cart') {
            window.location.href = vtPsState.root.dataset.cartUrl || '/cart';
            return;
          }
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = 'Add to cart';
          }, 1600);
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = 'Add to cart';
          if (msg) { msg.classList.add('is-error'); msg.textContent = err.message; }
        });
    }
  });

  /* ---------- Slider ---------- */
  function vtPsInit(root) {
    if (root.dataset.vtPsReady) return;
    root.dataset.vtPsReady = '1';

    var panels = root.querySelectorAll('[data-vt-ps-panel]');
    var tabs = root.querySelectorAll('[data-vt-ps-tab]');
    var prev = root.querySelector('[data-vt-ps-prev]');
    var next = root.querySelector('[data-vt-ps-next]');

    function activeTrack() {
      var visible = root.querySelector('[data-vt-ps-panel]:not([hidden])');
      return visible ? visible.querySelector('[data-vt-ps-track]') : null;
    }

    function updateArrows() {
      var track = activeTrack();
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.classList.toggle('is-hidden', track.scrollLeft <= 2);
      next.classList.toggle('is-hidden', track.scrollLeft >= max);
    }

    function step(dir) {
      var track = activeTrack();
      if (!track) return;
      var card = track.querySelector('[data-vt-ps-card]');
      var amount = card ? card.offsetWidth + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    root.querySelectorAll('[data-vt-ps-track]').forEach(function (t) {
      t.addEventListener('scroll', updateArrows, { passive: true });
    });
    window.addEventListener('resize', updateArrows);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.dataset.vtPsTab;
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.hidden = p.dataset.vtPsPanel !== index; });
        var track = activeTrack();
        if (track) track.scrollLeft = 0;
        updateArrows();
      });
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vt-ps-qv]');
      if (!btn) return;
      e.preventDefault();

      var handle = btn.dataset.handle;
      var url = btn.dataset.url;
      var base = root.dataset.rootUrl || '/';

      vtPsBuildPop();
      vtPsSetLoading();
      vtPsOpenPop();

      fetch(base.replace(/\/$/, '') + '/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Not found');
          return r.json();
        })
        .then(function (product) { vtPsRender(product, url, root); })
        .catch(function () { window.location.href = url; });
    });

    var speed = parseInt(root.dataset.autoplay, 10) || 0;
    if (speed > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () {
        var track = activeTrack();
        if (!track) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= max) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          step(1);
        }
      }, speed * 1000);

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
    }

    updateArrows();
  }

  function vtPsBoot() {
    document.querySelectorAll('[data-vt-ps]').forEach(vtPsInit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vtPsBoot);
  } else {
    vtPsBoot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-vt-ps]').forEach(vtPsInit);
  });
})();